<template>
  <v-dialog 
    :value="dialog" 
    persistent 
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Nous contacter</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea 
                label="Votre texte" 
                required
                outlined
                v-model="message"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn 
          :color="colors.secondary" 
          class="white-text"
          @click="closeModal()" 
          left
        >
          Annuler
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          :color="colors.primary"
          class="white-text" 
          @click="sendMessage()" 
          right
        >
          <v-icon right dark class="mr-2">mdi-send</v-icon> Envoyer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // EVENTS
  import { LOADING, LOADED, CLOSE_MODAL, SEND_MESSAGE } from '@/store/actions/general'
  import { SET_SNACK } from '@/store/actions/snackbar'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const UsersRepository = RepositoryFactory.get('users')

  export default {
    name: 'Contact',

    data() {
      return {
        colors: this.$vuetify.theme.themes.light,
        message: '',
      }
    },

    props: {
      dialog: {
        type: Boolean, 
        default: false,
      },
      subject: {
        type: String,
        default: 'Demande de contact',
      },
    },

    methods: {
      closeModal() {
        this.$emit(CLOSE_MODAL)
      },
      sendMessage() {
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        UsersRepository.postMessage(this.message, this.subject, customerApiToken)
        .then(({ data }) => {
          this.$store.commit(SET_SNACK, {
            message: 'Message envoyé',
            color: 'success',
          })
          this.message = ''
          this.closeModal()
        }).catch(err => {
          this.$store.commit(SET_SNACK, {
            message: 'Erreur lors de l\'envoi du message',
            color: 'error',
          })
        })
      }
    }
  }
</script>

<style scoped>
  .white-text {
    color: #fff !important;
  }
</style>